import { render } from "./LookforPassword.vue?vue&type=template&id=a74e76ae&scoped=true"
import script from "./LookforPassword.vue?vue&type=script&lang=js"
export * from "./LookforPassword.vue?vue&type=script&lang=js"

import "./LookforPassword.vue?vue&type=style&index=0&id=a74e76ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74e76ae"]])

export default __exports__